import React from 'react';
import LayersIcon from '@mui/icons-material/Layers';
import { InfoCard, Link, StructuredMetadataTable } from '@backstage/core-components';
import { ArgusStack, ArgusStackEnriched } from '@eng-portal/plugin-argus-common';
import { omit } from 'lodash';
import { getArgusAppComponentID } from '@eng-portal/czi-extensions-common';

type StackCardProps = {
  stack: ArgusStackEnriched
  useUtc?: boolean
  /** When provided along with envName, makes the title link to the stack explorer */
  appName?: string
  envName?: string
};

export function StackCard({ stack, useUtc, appName, envName }: StackCardProps): JSX.Element {
  const processedStack: Partial<ArgusStack> & { argocd_url?: JSX.Element; grafana_dashboard_url?: JSX.Element } = omit(
    stack.stack,
    'update_time',
    'env',
  );

  if (useUtc && processedStack.create_time) {
    processedStack.create_time = new Date(processedStack.create_time).toISOString();
  } else if (processedStack.create_time) {
    processedStack.create_time = new Date(processedStack.create_time).toLocaleString();
  }

  if (stack.info?.argo.url) {
    const link = stack.info.argo.url;
    processedStack.argocd_url = <Link to={link}>{link}</Link>;
  }
  if (stack.info?.grafana.dashboard_url) {
    const link = stack.info.grafana.dashboard_url;
    processedStack.grafana_dashboard_url = <Link to={link}>{link}</Link>;
  }

  // Build link to stack explorer if appName and envName are provided and stack info is available
  // if stack info is not available, the stack no longer exists in argus, so we don't need to link to it
  const stackLink = appName && envName && stack.stack.name && stack.info
    ? `/catalog/default/component/${getArgusAppComponentID(appName)}/argus-stacks?${new URLSearchParams({
        env: envName,
        stack: stack.stack.name,
      }).toString()}`
    : undefined;

  const customStackLink = stackLink ? <Link to={stackLink}>Stack</Link> : 'Stack';

  return (
    <InfoCard title="Stack" headerProps={{ title: customStackLink as any, avatar: <LayersIcon /> }}>
      <StructuredMetadataTable metadata={processedStack} />
    </InfoCard>
  );
}
